import React from "react"

export const ExternalLinkIcon = ({ size = 1, color = "#034055", ...rest }) => {
  return (
    <svg
      width={20.53 * size}
      height={20.5 * size}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.53 20.5"
      {...rest}
    >
      <path
        d="M21 11.63V21H3V3h10.31"
        transform="translate(-1.75 -1.75)"
        style={{
          fill: "none",
          stroke: color,
          strokeWidth: "2.5px",
        }}
      />
      <path
        d="m17.86 4.68-6.75 6.76 1.76 1.76 6.76-6.75 2.65 2.65V2h-7.07Z"
        transform="translate(-1.75 -1.75)"
        style={{
          fill: color,
        }}
      />
    </svg>
  )
}
